export const loader = () => {
	document.getElementById('loader').style.display = 'none';
}